import { Container, Flex, IconButton, Text } from '@chakra-ui/react'
import styled from '@emotion/styled'
import { motion } from 'framer-motion'

import * as React from 'react'

import { useMediaQuery } from 'react-responsive'
import { RouteComponentProps, withRouter } from 'react-router'

import { color, ColorProps, space, SpaceProps } from 'styled-system'

import { useAppContext } from '../../context/AppProvider'
import { useAuthContext } from '../../context/AuthProvider'

import { LANGUAGES, MENU1_WIDTH, MENU2_WIDTH } from '../../constants'
import ProfileButton from '../ProfileButton'
import SideBarButton from '../AdminSideBar/SideBarButton'
import { useHistory } from 'react-router-dom'
import { SecondaryButton } from 'components/Buttons'
import { VscSettings } from 'react-icons/vsc'
import { get } from 'js-cookie'
import { LangSelector } from 'components'

type HeaderProps = RouteComponentProps &
  ColorProps & {
    color?: string
    size?: number
    id?: string
    open?: boolean
    getLoggedInUser?: () => { name?: string; id: string }
  }

type HeaderContProps = SpaceProps &
  ColorProps & {
    color?: string
    open?: boolean
  }

const HeaderCont = styled(motion.div)<HeaderContProps>`
  ${space};
  ${color};
  top: 0;
  right: 0;
  height: 64px;
  z-index: 1290;
  display: flex;
  position: fixed;
  align-items: center;
  flex-direction: row;
  box-sizing: border-box;
  justify-content: space-between;
  left: ${(props) => (props.open ? '230px' : '64px')};
  @media screen and (max-width: 40em) {
    left: 0;
  }
  transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
`

export const BreadCrumbCont = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  @media screen and (max-width: 40em) {
    display: none;
  }
`

const Header: React.FC<HeaderProps> = ({ ...rest }) => {
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 40em)' })
  const history = useHistory()

  const { user, logout, isAdmin } = useAuthContext()
  const { drawerOpen, toggleDrawer, secondaryDrawerOpen } = useAppContext()

  const { icon } = LANGUAGES.find((l) => l.code === get('lng')) || { code: 'en' }

  const handleLogout = () => {
    logout && logout()
    history.push('/')
  }

  return (
    <HeaderCont
      pl={drawerOpen ? (MENU1_WIDTH + 50) / 2 : 0}
      pr={secondaryDrawerOpen ? MENU2_WIDTH : isTabletOrMobile ? 0 : '2rem'}
      {...rest}
    >
      <Container pr={12} maxW="container.xl">
        <Flex align="center">
          <Flex justify="center" align="center">
            {!isTabletOrMobile && (
              <SideBarButton color="black" open={drawerOpen} onClick={toggleDrawer} />
            )}
          </Flex>
          {isTabletOrMobile && (
            <SideBarButton color="black" open={drawerOpen} onClick={toggleDrawer} />
          )}
          <Flex flex={1} justify="flex-end" align="center" direction="row" height="100%">
            {!isTabletOrMobile && (
              <LangSelector mx={4}>
                <Text fontSize="xs">
                  {icon} {get('lng')}
                </Text>
              </LangSelector>
            )}
            <SecondaryButton
              onClick={() => {
                history.push('/auth')
              }}
              mr={4}
              borderColor="transparent"
              color="red.500"
              rounded="full"
            >
              Exit Admin Mode
            </SecondaryButton>{' '}
            <Flex flexDirection="row" justifyContent="center" alignItems="center" height="100%">
              {isAdmin && (
                <IconButton
                  aria-label="Settings"
                  icon={<VscSettings />}
                  onClick={() => {
                    history.push('/auth/dashboard/settings/agency-info')
                  }}
                  variant="ghost"
                  rounded="full"
                  colorScheme="gray"
                  mr={4}
                />
              )}

              <ProfileButton user={user} onLogout={handleLogout} />
            </Flex>
          </Flex>
        </Flex>
      </Container>
    </HeaderCont>
  )
}

export default withRouter(Header)

Header.defaultProps = {
  bg: 'white'
}
